import React, {CSSProperties} from "react";

import {Button, Radio} from "antd";
import {IClusterPlanShortItem} from "../../../api/apiTypes";

interface Props {
  plan: IClusterPlanShortItem;
  selected: boolean;
  style?: CSSProperties;
  onSelect: (plan: IClusterPlanShortItem) => void;
}

const PlanItem = ({selected, onSelect, plan, style}: Props) => {
  const handleSelect = (e: any) => {
    if (!selected) onSelect(plan);
  };
  
  return (<Button
    type={"text"}
    style={style}
    className={"item"}
    onClick={handleSelect}
  >
    <Radio className={"text"} checked={selected} onChange={handleSelect}>
      {plan.cluster_id}
    </Radio>
    <span className={"type text"}>
        {plan.shipping_item_count}
      </span>
  </Button>);
};

export default PlanItem;
